/*
 * L'AUDACE product carousel
 * Native horizontal scroll-snap track (touch swipe and trackpad work out of the box),
 * plus: arrow buttons that page through the cards, mouse click-and-drag, and arrows
 * that hide themselves when there is nothing to scroll to.
 */
if (!customElements.get('laudace-carousel')) {
  class LaudaceCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.laudace-carousel__track');
      this.prev = this.querySelector('.laudace-carousel__arrow--prev');
      this.next = this.querySelector('.laudace-carousel__arrow--next');
      if (!this.track) return;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.dragged = false;

      this.prev && this.prev.addEventListener('click', () => this.page(-1));
      this.next && this.next.addEventListener('click', () => this.page(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update());
      if ('ResizeObserver' in window) new ResizeObserver(() => this.update()).observe(this.track);

      this.bindDrag();
      this.update();
    }

    page(direction) {
      const item = this.track.querySelector('.laudace-carousel__item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = item.getBoundingClientRect().width + gap;
      const visible = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
      this.track.scrollBy({
        left: direction * step * Math.max(1, visible - 1),
        behavior: this.reduceMotion ? 'auto' : 'smooth',
      });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const overflow = max > 2;
      if (this.prev) this.prev.hidden = !overflow || this.track.scrollLeft <= 2;
      if (this.next) this.next.hidden = !overflow || this.track.scrollLeft >= max - 2;
    }

    bindDrag() {
      let startX = 0;
      let startLeft = 0;
      let down = false;

      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true;
        this.dragged = false;
        startX = e.clientX;
        startLeft = this.track.scrollLeft;
      });

      window.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        if (!this.dragged && Math.abs(dx) > 6) {
          this.dragged = true;
          this.track.classList.add('is-dragging');
        }
        if (this.dragged) this.track.scrollLeft = startLeft - dx;
      });

      const end = () => {
        if (!down) return;
        down = false;
        this.track.classList.remove('is-dragging');
        // let snap settle on the nearest card
        if (this.dragged) {
          const item = this.track.querySelector('.laudace-carousel__item');
          if (item) {
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            const step = item.getBoundingClientRect().width + gap;
            this.track.scrollTo({
              left: Math.round(this.track.scrollLeft / step) * step,
              behavior: this.reduceMotion ? 'auto' : 'smooth',
            });
          }
        }
      };
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);

      // a drag must not open the product under the cursor
      this.track.addEventListener(
        'click',
        (e) => {
          if (this.dragged) {
            e.preventDefault();
            e.stopPropagation();
            this.dragged = false;
          }
        },
        true
      );
    }
  }

  customElements.define('laudace-carousel', LaudaceCarousel);
}
